'use client';

import { c as _c } from "react/compiler-runtime";
import { createContext, type PropsWithChildren, useContext, useRef } from 'react';
export type ApprovalOddsFunnelIds = {
  expandActivityId?: string;
  identitySubmitActivityId?: string;
  verifyViewActivityId?: string;
  verifySubmitActivityId?: string;
};
export type ApprovalOddsFunnelRef = {
  current: ApprovalOddsFunnelIds;
};

// Parent activity ids for the approval-odds activation flow (banner expand → identity → verify).
// A ref, not state: steps write these ids as they track, and that must not re-render the form.
export const ApprovalOddsFunnelContext = createContext<ApprovalOddsFunnelRef | null>(null);
export function ApprovalOddsFunnelProvider(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const funnelIds = useRef(t1);
  let t2;
  if ($[1] !== children) {
    t2 = <ApprovalOddsFunnelContext.Provider value={funnelIds}>{children}</ApprovalOddsFunnelContext.Provider>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
}
export function useApprovalOddsFunnelIds() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {};
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const fallback = useRef(t0);
  return useContext(ApprovalOddsFunnelContext) ?? fallback;
}